import { Map } from 'immutable';
import { getFeature } from './actions';

export const DEFAULT_FEATURE_STATE = Map();

const feature = (state = DEFAULT_FEATURE_STATE, { type, payload }) => {
  switch (type) {
    case getFeature.event.success:
      return {
        ...state,
        [payload.featureKey]: payload.response
      };

    default:
      return state;
  }
};

export default feature;
